import { render } from "./TeamMembersModal.vue?vue&type=template&id=45d9ea74&scoped=true"
import script from "./TeamMembersModal.vue?vue&type=script&lang=js"
export * from "./TeamMembersModal.vue?vue&type=script&lang=js"

import "./TeamMembersModal.vue?vue&type=style&index=0&id=45d9ea74&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d9ea74"]])

export default __exports__